<template>
  <div class="detail-page">
    <header>
      <button
        type="button"
        :aria-label="$t('yuebao.back')"
        @click="$router.back()"
      >
        ‹
      </button><h1>{{ $t('yuebao.orderDetail') }}</h1><span />
    </header>
    <main>
      <section class="status-card">
        <span>{{ $t('yuebao.orderStatus') }}</span><strong>{{ statusText(detail.status) }}</strong><p>{{ $t('yuebao.orderNo') }}：{{ display(detail.order_no || $route.params.orderNo) }}</p>
      </section>
      <section class="card">
        <h2>{{ $t('yuebao.productInfo') }}</h2><Row
          :label="$t('yuebao.product')"
          :value="display(detail.product_name, $t('yuebao.unnamedProduct'))"
        /><Row
          :label="$t('yuebao.annualRate')"
          :value="rate(detail)"
        /><Row
          :label="$t('yuebao.term')"
          :value="term(detail)"
        /><Row
          :label="$t('yuebao.interestMethod')"
          :value="$t('yuebao.dailyInterest')"
        />
      </section>
      <section class="card">
        <h2>{{ $t('yuebao.fundInfo') }}</h2><Row
          :label="$t('yuebao.principal')"
          :value="$t('utils.moneyMark') + money(principal(detail))"
        /><Row
          :label="$t('yuebao.expectedInterest')"
          :value="$t('utils.moneyMark') + money(detail.expected_interest)"
          value-class="income"
        /><Row
          :label="$t('yuebao.paidInterest')"
          :value="$t('utils.moneyMark') + money(detail.paid_interest)"
          value-class="income"
        /><Row
          :label="$t('yuebao.startTime')"
          :value="display(detail.start_at)"
        /><Row
          :label="$t('yuebao.endTime')"
          :value="display(detail.due_at)"
        /><Row
          :label="$t('yuebao.settlementTime')"
          :value="display(detail.settled_at)"
        />
      </section>
      <p class="notice">
        {{ $t('yuebao.noEarlyRedeem') }}
      </p>
    </main>
  </div>
</template>
<script>
import Fetch from '../../../utils/fetch';
const Row = { functional: true, props: ['label', 'value', 'valueClass'], render(h, ctx) { return h('div', { class: 'detail-row' }, [h('span', ctx.props.label), h('strong', { class: ctx.props.valueClass }, ctx.props.value)]); } };
export default { name: 'YuebaoOrderDetail', components: { Row }, data() { return { detail: {} }; }, created() { this.$parent.footer('user', false); }, mounted() { Fetch('/yuebao/order_detail', { order_no: this.$route.params.orderNo }).then(r => { this.detail = r.data || {}; }).catch(() => {}); }, methods: { display(value, fallback) { return value == null || value === '' ? (fallback || '--') : value; }, money(value) { const n = Number(value); return Number.isFinite(n) ? n.toFixed(2) : '0.00'; }, principal(item) { return item.principal; }, rate(item) { const value = item.annual_rate; return value == null || value === '' ? '--' : String(value).replace(/%$/, '') + '%'; }, term(item) { return item.term_days == null || item.term_days === '' ? '--' : item.term_days + this.$t('utils.day'); }, statusText(status) { return { '0': this.$t('yuebao.statusHolding'), '1': this.$t('yuebao.statusSettling'), '2': this.$t('yuebao.statusDue'), '3': this.$t('yuebao.statusAdminSettled') }[String(status)] || this.$t('yuebao.statusUnknown'); } } };
</script>
<style lang="less" scoped>
* { box-sizing: border-box; }
.detail-page { min-width: 0; min-height: 100vh; overflow-x: hidden; background: #f4f6f9; color: #282d37; } header { display: flex; align-items: center; justify-content: space-between; height: 54px; padding: 0 12px; color: #fff; background: #2672e8; h1 { font-size: 18px; } button, span { width: 48px; border: 0; color: #fff; background: transparent; font-size: 34px; text-align: left; } } main { padding: 12px; }.status-card { padding: 22px 18px; border-radius: 9px; color: #fff; background: #2672e8; span { color: rgba(255,255,255,.75); font-size: 12px; } strong { display: block; margin-top: 8px; font-size: 23px; } p { margin-top: 15px; color: rgba(255,255,255,.75); font-size: 11px; line-height: 17px; word-break: break-all; } }.card { margin-top: 12px; padding: 5px 16px; border: 1px solid #e9edf2; border-radius: 9px; background: #fff; h2 { padding: 14px 0 12px; border-bottom: 1px solid #e9edf2; font-size: 15px; } }.notice { padding: 15px 5px; color: #8e95a1; font-size: 11px; text-align: center; }
/deep/ .detail-row { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; padding: 13px 0; border-bottom: 1px solid #f0f2f5; font-size: 13px; span { flex: 0 0 auto; color: #7f8794; } strong { min-width: 0; max-width: 64%; font-weight: 500; text-align: right; word-break: break-all; }.income { color: #e66634; } }
@media (max-width: 340px) { main { padding: 8px; }.status-card { padding: 19px 15px; }.card { padding: 5px 13px; } /deep/ .detail-row { gap: 10px; } }
</style>
